<template>
  <div class="info-page">
    <crumbs title="专题赛通知公告" />
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      label-position="right"
      label-width="auto"
    >
      <div class="info-page__item">
        <div class="info-page__title">
          <span>详细信息</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="通知标题" prop="title">
              <el-input
                v-model="form.title"
                placeholder="请输入通知标题"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="是否置顶" prop="isTop">
              <el-switch
                v-model="form.isTop"
                :active-value="true"
                :inactive-value="false"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="发布时间" prop="distributeDate">
              <el-date-picker
                v-model="form.distributeDate"
                type="datetime"
                placeholder="请选择发布时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                prefix-icon="el-icon-date"
                style="width: 100%"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="通知内容" prop="content">
              <editor
                v-model="form.content"
                imgUploadUrl="/api/achievement/uploadachiattach"
              ></editor>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="图片上传" prop="imgUploadList">
              <image-upload
                url="/api/Achievement/UploadAchiAttach"
                accept="image/jpeg,image/png,image/bmp,image/webp"
                :file-list.sync="form.imgUploadList"
                :multiple="false"
                :num-limit="1"
                :size-limit="10"
              >
                <template>
                  <el-alert
                    :title="`上传图片格式要求 jpg、jpeg、webp、bmp、png；每个大小不超过10MB；图片名(包含后缀名)的最大长度为100个字符。`"
                    type="warning"
                  >
                  </el-alert>
                </template>
              </image-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="附件上传" prop="fileUploadList">
              <file-upload
                url="/api/Achievement/UploadAchiAttach"
                :file-list.sync="form.fileUploadList"
                accept="text/plain,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                :num-limit="0"
              >
                <el-alert
                  style="margin-top: 10px; line-height: normal"
                  :title="`上传文件格式要求ppt、pdf、doc、docx、txt、xls、xlsx；文件名(包含后缀名)的最大长度为100个字符`"
                  type="warning"
                >
                </el-alert>
              </file-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <div class="submit fn-text-center mt-20">
      <template v-if="isAdd">
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerAddData('ruleForm')"
          >提交</el-button
        >
      </template>
      <template v-else>
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerModifyData('ruleForm')"
          >提交</el-button
        >
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "contestNoticeInfo",
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      // 是否处于loading状态
      isLoading: false,
      //是添加数据还是修改数据
      isAdd: true,
      //表单
      form: {
        title: "",
        isTop: false,
        distributeDate: "",
        content: "",
        imgUploadList: [], // imgURL 相对应
        fileUploadList: [] // attachments 相对应
      },
      rules: {
        title: [isEmpty("请输入通知标题")],
        distributeDate: [isEmpty("请选择发布时间", "change")],
        content: [isEmpty("请编辑通知内容")]
      }
    };
  },
  created() {
    const { method } = this.$route.params;
    // 默认值 走添加流程
    let isAdd = true;
    if (method === "modification") {
      //获取信息
      this.loadInfo();
      //走修改流程
      isAdd = false;
    }
    this.isAdd = isAdd;
  },
  methods: {
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      const {
        // list
        imgUploadList,
        fileUploadList,
        ...others
      } = this.form;
      // 处理上传文件
      const deconstruct1 = (file = {}) => {
        return file.response ? file.response.dataList[0] : file;
      };
      const attachments = fileUploadList.map((item) => {
        return deconstruct1(item);
      });
      // 处理上传图片
      const deconstruct2 = (file = {}) => {
        return file.response ? file.response.dataList[0].url : file.url || "";
      };
      const imgURL = deconstruct2(imgUploadList[0]);
      return {
        ...others,
        imgURL,
        attachments
      };
    },
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      const { imgURL, attachments, ...others } = data;
      // 处理文件
      const file = this.turnNulltoString(attachments);
      const fileUploadList = file === "" ? [] : file;
      const img = this.turnNulltoString(imgURL);
      const imgUploadList =
        img === ""
          ? []
          : [
              {
                url: img
              }
            ];

      return {
        ...others,
        imgUploadList,
        fileUploadList
      };
    },
    // 点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAddData();
        }
      });
    },
    // 点击修改数据按钮
    handlerModifyData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadModifyData();
        }
      });
    },
    // 加载添加数据接口
    loadAddData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("competition", "addNotice", params).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载修改数据接口
    loadModifyData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      const { id } = this.$route.query;
      this.$api("competition", "addNotice", {
        ...params,
        noticeId: id
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载数据接口
    loadInfo() {
      const { id } = this.$route.query;
      this.$api("competition", "getNoticeInfo", { id }).then((res) => {
        const { code, message } = res;
        if (code === 0) {
          this.form = this.downloadProcessData(res.dataList[0]);
        } else {
          this.$message.error(message);
          this.redirectTo();
        }
      });
    },
    // 返回列表页
    redirectTo() {
      // this.redirectByPath(`/admin/competitionManage/contestNoticeList`);
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped></style>
